export default "__VITE_ASSET__BdFEqaUb__"